import { render, staticRenderFns } from "./MultiLayerRadarChart.vue?vue&type=template&id=36b0ed3f&scoped=true&"
import script from "./MultiLayerRadarChart.vue?vue&type=script&lang=js&"
export * from "./MultiLayerRadarChart.vue?vue&type=script&lang=js&"
import style0 from "./MultiLayerRadarChart.vue?vue&type=style&index=0&id=36b0ed3f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b0ed3f",
  null
  
)

export default component.exports